import {ReactComponent as BuyImage} from 'assets/images/farm/add/buy.svg';
import {ReactComponent as WantedImage} from 'assets/images/farm/add/wanted.svg';
import {ReactComponent as MarketBuy} from 'assets/images/wholesaler/add/buy.svg';
import {ReactComponent as MarketWanted} from 'assets/images/wholesaler/add/wanted.svg';
export const categoryItems: ICategoryItems[] = [
  {
    id: 0,
    icon: <BuyImage />,
    title: 'فروش محصول',
    route: '/type-ads',
    marketIcon: <MarketBuy />,
    role: 'post',
  },
  {
    id: 1,
    icon: <WantedImage />,
    title: 'خرید محصول',
    route: '/purchase',
    marketIcon: <MarketWanted />,
    role: 'wanted',
  },
];
